import { Snackbar, Alert } from '@mui/material'
import { useAppDispatch, useAppSelector } from 'src/store/hooks'
import {
  selectSuccessMessage,
  selectErrorMessage,
  successMessageChanged,
  errorMessageChanged,
} from 'src/v3/manage/manage.slice'

export default function NotificationSnackbars() {
  let dispatch = useAppDispatch()
  let successMessage = useAppSelector(selectSuccessMessage)
  let errorMessage = useAppSelector(selectErrorMessage)

  return (
    <>
      <Snackbar
        open={!!successMessage}
        autoHideDuration={3000}
        onClose={() => dispatch(successMessageChanged(''))}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert
          onClose={() => dispatch(successMessageChanged(''))}
          severity="success"
          variant="filled"
        >
          {successMessage}
        </Alert>
      </Snackbar>

      <Snackbar
        open={!!errorMessage}
        autoHideDuration={3000}
        onClose={() => dispatch(errorMessageChanged(''))}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert
          onClose={() => dispatch(errorMessageChanged(''))}
          severity="error"
          variant="filled"
        >
          {errorMessage}
        </Alert>
      </Snackbar>
    </>
  )
}
